module.exports = __webpack_public_path__ + "img/status-support.547c4a4c.png";